import React, { useEffect } from 'react';
import { HashRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
// Home has been replaced by Demo
import AboutUs from './pages/AboutUs';
import OurCreations from './pages/OurCreations';
import OurValues from './pages/OurValues';
import Contact from './pages/Contact';
import Expertises from './pages/Expertises';
import Collections from './pages/Collections';
import MaLuxPensee from './pages/MaLuxPensee';
import Demo from './pages/Demo';
import Blogs from './pages/Blogs';
import Admin from './pages/Admin';
import './styles/main.css';

function ScrollToTop() {
    const { pathname } = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    
    return null;
}

function App() {
    useEffect(() => {
        // Prevent browser from restoring scroll position
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <Header />

            <Switch>
                <Route exact path="/" component={Demo} />
                <Route path="/about-us" component={AboutUs} />
                <Route path="/expertises" component={Expertises} />
                <Route path="/collections" component={Collections} />
                <Route path="/ma-lux-pensee" component={MaLuxPensee} />
                <Route path="/blogs" component={Blogs} />
                <Route path="/contact" component={Contact} />
                <Route path="/our-creations" component={OurCreations} />
                <Route path="/our-values" component={OurValues} />
                <Route path="/admin" component={Admin} />
                <Route component={Demo} />
            </Switch>

            <Footer />
        </Router>
    );
}

export default App;